import { dispatch } from '../../jsCore/application/appStore'
import { CLASS_CONSTATNTS } from '../../jsCore/organizedByType/actions/analyticsActions'

function pushConsentToDataLayer(consent) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'user consent status',
        label: ' ',
        cookieConsent: consent,
      },
    },
  }
}

export function init() {
  window.__cmp('getConsentData', null, function(result) {
    console.log('result-getConsentData', result)
    localStorage.setItem('gdprApplies', result.gdprApplies)
    localStorage.setItem('consentData', result.consentData)
    if (null !== result.consentData) {
      dispatch(pushConsentToDataLayer(result.consentData))
    }
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookie_consent/cookieConsentUtils.js